import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";

orderApprovalDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    buttonType: "outline",
}

orderApprovalDetailsActionButtonsStyles.twoButtonModalStyles = {
    submitButton:{
        color:"primary",
        variant: "primary",
    }
}